import { createMergeReducer } from '../utils/reducer'

export type TitleIdToSeasonIds = {
  [titleId: string]: string[] | undefined
}

export const reducer = createMergeReducer(
  t => t.seasons,
  {} as TitleIdToSeasonIds
)
